module.exports = ".car-status.is-hidden img {\n    height: 0px;\n}\n\nhtml, body, #map_canvas {\n    height: 100%;\n    width: 100%;\n    margin: 0px;\n}\n\n#map_canvas {\n    position: fixed !important;\n}\n\n.car-status img.is-hidden {\n    height: 0px;\n    width: 0px;\n    display: none;\n}\n\n.is-hidden {\n    display: none;\n}\n\n.car-status div.is-hidden {\n    height: 0px;\n    width: 0px;\n    display: none;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/view/state/state.component.css
// module id = ./src/app/view/state/state.component.css
// module chunks = main